import React from "react";
import PropTypes from "prop-types";

const CheckBox = React.forwardRef(
  ({ value, name, label, children, checked, ...rest }, ref) => {
    return (
      <div className="relative">
        <label className="flex items-center">
          <input
            checked={checked}
            type="checkbox"
            name={name || label}
            value={value}
            ref={ref}
            className="form-checkbox rounded-theme bg-white h-4 w-4 border border-gray-300 text-accent shadow-sm focus:border-0 focus:ring-1 focus:ring-accent"
            {...rest}
            {...children}
          />
          {label && (
            <span className="font-medium text-gray-700 p-1">{label}</span>
          )}
        </label>
      </div>
    );
  }
);

CheckBox.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.bool,
  children: PropTypes.node,
  rest: PropTypes.any,
};

CheckBox.displayName = "CheckBox";

export default CheckBox;
